<template>
  <v-card
    hover
    height="100%"
  >
    <v-container
      fluid
      class="fill-height ma-0 pa-0"
    >
      <v-layout
        column
        class="ma-0 pa-0"
      >
       <v-flex
          shrink
          class="pa-0 ma-0"
          v-if="betrieb.offiziellername && betrieb.offiziellername!=betrieb.vollername"
        >
          
          <v-layout
            row
            class="px-3 pt-3 pb-0"
          >
          <v-flex>{{ betrieb.offiziellername }}</v-flex>
          </v-layout>
          <v-divider class="grey lighten-3"></v-divider>
       </v-flex>
        <v-flex class="ma-0 pa-0 fill-height">
          <v-card-title
            primary-title
            class="cardbackground py-0 xmouseoverlink"
            width="100%"
          >
            <v-container
              fluid
              class="ma-0 pa-0"
            >
              <v-layout
                row
                grow
                class="ma-0 pa-0"
              >
                <v-flex class="ma-0 pa-0">
                  <router-link
                    :to="{ name: 'showCompany', params: { id: betrieb.slug } }"
                    tag="h3"
                    v-if="betrieb.website_ext === 0"
                  >
                    <div
                      v-if="betrieb.image_logo"
                      class="px-0 mb-3 mt-2"
                    >
                      <v-img
                        :src="betrieb.image_logo"
                        contain
                        min-height="150px"
                        max-height="200px"
                      ></v-img>
                    </div>
                    <h3
                      style="line-height: 1.6 !important"
                      class="linehoeher mt-2 title"
                      flat
                    >
                    {{ betrieb.vollername }}
                    </h3>
                  </router-link>
                    <a :href="betrieb.website" target="_blank"
                    v-if="betrieb.website_ext === 1"
                  >
                    <div
                      v-if="betrieb.image_logo"
                      class="px-0 mb-3 mt-2"
                    >
                      <v-img
                        :src="betrieb.image_logo"
                        contain
                        min-height="150px"
                        max-height="200px"
                      ></v-img>
                    </div>
                    <h3
                      style="line-height: 1.6 !important"
                      class="linehoeher mt-2 title"
                      flat
                    >
                      {{ betrieb.vollername }}
                    </h3>
                  </a>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>
          <v-card-title class="pt-0 pb-1 my-0 subheading grey--text text--darken-3">in {{ betrieb.stadtmitteil }}
            <span
              class="ml-auto"
              v-if="betrieb.entfernung"
            >
              {{ betrieb.entfernung }} km
            </span>
          </v-card-title>
        </v-flex>

        <v-flex
          style="position: relative;"
          class="ma-0 pa-0"
          v-if="betrieb.verfuegbar"
        >
          <v-divider class="grey lighten-3"></v-divider>
          <v-list class="py-1 my-0">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon
                  color="green"
                  large
                >check_circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Verfügbar</v-list-tile-title>

              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
        <v-flex
          class="ma-0 pa-0"
          v-if="betrieb.beschreibung"
        >
          <v-card-text class="pa-3">{{ betrieb.beschreibung }}</v-card-text>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex
          shrink
          class="pa-0 ma-0"
        >
          <v-divider class="grey lighten-3"></v-divider>
          <v-layout
            row
            class="px-3 py-1"
            v-for="innung in Innungkombi"
            :key="innung.name"
          >
            <v-flex
              xs9
              align-self-center
              class="xsubheading"
            >{{ innung.name }}</v-flex>
            <v-flex v-if="innung.logo">
              <v-img
                min-height="50px"
                max-height="70px"
                contain
                :src="innung.logo"
              ></v-img>
            </v-flex>
          </v-layout>

          <v-divider></v-divider>
          <span v-if="betrieb.zertifikate">
            <span v-if="betrieb.zertifikate.length > 0">
              <v-card
                flat
                class="my-2 grey lighten-5"
              >
                <v-layout
                  row
                  class="px-3 py-1"
                  v-for="cert in betrieb.zertifikate"
                  :key="cert.name"
                >
                  <v-flex
                    xs7
                    align-self-center
                  >{{ cert.name }}</v-flex>
                  <v-flex v-if="cert.logo">
                    <v-img
                      contain
                      :src="cert.logo"
                      max-height="80px"
                      position="right"
                    ></v-img>
                  </v-flex>
                </v-layout>
              </v-card>
              <v-divider></v-divider>
            </span>
          </span>
        </v-flex>
        <v-flex
          shrink
          class="pa-0 ma-0"
        >
          <v-card-actions
            class="px-0 my-0 grey lighten-5"
            style="width: 100%;"
          >
            <v-layout
              row
              wrap
              fill-height
              align-end
            >
              <v-flex class="py-0 pl-2">
                <v-list
                  class="grey lighten-5 py-0 my-0"
                  two-line
                  v-if="betrieb.telefon"
                >
                  <v-list-tile
                    class="grey lighten-5"
                    v-bind:href="'tel:' + betrieb.telefon_link"
                  >
                    <v-list-tile-action>
                      <v-icon color="primary">phone</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                      betrieb.telefon
                    }}</v-list-tile-title>
                      <v-list-tile-sub-title>Telefon</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
                <v-divider></v-divider>
                <v-list class="grey lighten-5 pt-0 pb-1 my-0">
                  <v-list-tile class="ma-0 pa-0 grey lighten-5">
                    <v-list-tile-action class="ma-0 pa-0">
                      <listing-save :company="betrieb"></listing-save>
                    </v-list-tile-action>
                    <!-- <v-list-tile-action v-if="betrieb.connected">
                  <v-icon color="primary">check_circle</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-action v-if="betrieb.website">
                      <v-icon color="primary">web_asset</v-icon>
                  </v-list-tile-action> -->
                    <v-list-tile-action v-if="betrieb.email">
                      <v-btn
                        icon
                        v-bind:href="`mailto:${betrieb.email}`"
                      >
                        <v-icon color="primary">mail_outline</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-spacer></v-spacer>
                    <v-list-tile-action class="ma-0 pa-0">
                      <v-btn
                        flat
                        light
                        :to="{
                        name: 'showCompany',
                        params: { id: betrieb.slug }
                      }"
                        v-if="betrieb.premium === 0"
                      >Mehr</v-btn>
                      <v-btn
                        flat
                        light
                        class="px-2"
                        :large="betrieb.profilfarbe ? true : false"
                        :to="{
                        name: 'showCompany',
                        params: { id: betrieb.slug }
                      }"
                        :color="betrieb.profilfarbe"
                        v-if="betrieb.premium === 1 && betrieb.website_ext === 0"
                      >
                        <v-icon
                          :color="betrieb.profilfarbe"
                          left
                          v-if="betrieb.premium_freigeschaltet === 1"
                        >check_circle_outline</v-icon>
                        BetriebsProfil
                      </v-btn>

                      <v-btn
                        flat
                        light
                        class="px-2"
                        :large="betrieb.profilfarbe ? true : false"
                        :href="betrieb.website"
                        target="_blank"
                        :color="betrieb.profilfarbe"
                        v-if="betrieb.premium === 1 && betrieb.website_ext === 1"
                      >
                        <v-icon
                          :color="betrieb.profilfarbe"
                          left
                          v-if="betrieb.premium_freigeschaltet === 1"
                        >open_in_new</v-icon>
                          Homepage
                      </v-btn>


                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
// import { mapGetters } from 'vuex'
import ListingSave from '~/components/ListingSave.vue'

export default {
  props: ['betrieb'],
  components: {
    ListingSave
  },

  data () {
    return {
      betriebcheckloading: true
    }
  },
  computed: {
    // Depre
    // Stadtteil: function () {
    //   if (this.betrieb) {
    //     var stadtteilnullfix = this.betrieb.stadtteil || ' '
    //     return this.betrieb.stadt + ' ' + stadtteilnullfix
    //   }
    // },
    Innungkombi: function () {
      const superinnung = {}
      if (this.betrieb.innung) {
        if (this.betrieb.innungen) {
          const superinnnug = [].concat(
            this.betrieb.innung,
            this.betrieb.innungen
          )
          return superinnnug
        } else {
          return this.betrieb.innung
        }
      } else if (this.betrieb.innungen) {
        const superinnung = this.betrieb.innungen
        return superinnung
      }
      return superinnung
    }
  },
  mounted: function () {},
  methods: {}
}
</script>

<style>
.v-card--reveal {
  align-items: center;
  bottom: 0px;
  justify-content: center;
  opacity: 0.6;
  position: absolute;
  width: 100%;
  z-index: 2;
}
</style>
